import { LicenseObjectSchema as OriginalLicenseObjectSchema } from '../processed/license-object'

/**
 * License Object
 *
 * License information for the exposed API.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#license-object
 */
export const LicenseObjectSchema = OriginalLicenseObjectSchema
